export default __webpack_public_path__ + "static/media/Grandeur_large_13.99c85741.jpg";